import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  role: "presentation"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.5 21v-2a3.5 3.5 0 0 0-3.5-3.5h-4A3.5 3.5 0 0 0 6.5 19v2a.5.5 0 0 1-1 0v-2a4.5 4.5 0 0 1 4.5-4.5h4a4.5 4.5 0 0 1 4.5 4.5v2a.5.5 0 0 1-1 0m-2-14a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0m1 0a4.5 4.5 0 1 1-8.998 0A4.5 4.5 0 0 1 16.5 7"
    }, null, -1)
  ]))]))
}
export default { render: render }